import { Cadastro } from './../../../../../shared/interfaces/cadastro';
import { Component, Inject, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { Endereco } from 'app/shared/interfaces/endereco';
import { PageResult } from 'app/shared/interfaces/page-result';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { CadastroService } from 'app/shared/services/cadastro.service';
import { CepService } from 'app/shared/services/cep.service';
import { EnderecoPopupComponent } from '../endereco-popup/endereco-popup.component';
import { Cidade } from 'app/shared/interfaces/cidade';

@Component({
  selector: 'app-cadastro-endereco-popup',
  templateUrl: './cadastro-endereco-popup.component.html',
  styleUrls: ['./cadastro-endereco-popup.component.scss']
})
export class CadastroEnderecoPopupComponent implements OnInit {

  @ViewChild(MatPaginator, { static: false }) paginatorEndereco: MatPaginator;
  
  layoutConf: any;
  pageObjectEndereco$: BehaviorSubject<PageResult<Endereco>> = new BehaviorSubject<PageResult<Endereco>>(null);
  enderecos: Endereco[];
  pageEndereco = 1;
  lengthEndereco = 0;
  pageSizeEndereco = 5;
  pageEventEndereco = null;
  pageSizeOptionsEndereco: number[] = [5, 10, 25];
  cadastro: Cadastro;
  selectedOrdem = 'NENHUM';
  selectedDirect = 'ASC';
  dialogRefEndereco: MatDialogRef<any>;




  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CadastroEnderecoPopupComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private layout: LayoutService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private snack: MatSnackBar,
    private authService: JwtAuthService,
    private loader: AppLoaderService,
    private cadastroService: CadastroService,
    private cepService: CepService,
  ) { }

  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;
    this.cadastro = this.data.payload;
    console.log(`Cadastro: ${this.cadastro.codigo} - ${this.cadastro.razaoSocial}`);


    this.pageObjectEndereco$.subscribe(
      page => {
        if (page != null) {
          this.enderecos = page.content;
          this.lengthEndereco = page.totalElements;
          this.pageSizeEndereco = page.size;
          this.pageEndereco = page.number;
          if (this.pageEndereco === 1) {
            this.paginatorEndereco.firstPage();
          }
        } else {
          this.enderecos = [];
        }
      });

      this.getPageEndereco(this.pageEndereco, this.pageSizeEndereco, this.cadastro.id);  
  }

  getPageEndereco(page: number, pageSize: number, id: number) {
    if (id !== undefined) {
      this.cadastroService.getPageEndereco(page, pageSize, this.selectedOrdem
        , this.selectedDirect, id.toString()).subscribe(val => { this.pageObjectEndereco$.next(val) })
    }
  }

  reloadPageEndereco() {
    this.pageEndereco = 1;
    this.getPageEndereco(this.pageEndereco, this.pageSizeEndereco, this.cadastro.id);
  }

  deleteEndereco(data: any = {}, isNew?) {
    this.confirmService.confirm({ message: `Deletar ${data?.endereco + '-' + data?.numero}?` })
      .subscribe(res => {
        if (res) {
          this.loader.open();
          this.cadastroService.deleteCadastroEndereco(data.id)
            .subscribe(data2 => {
              this.loader.close();
              this.confirmService.confirm({
                title: data2.status ? 'Sucesso' : 'Erro', message: data2.status
                  ? `Endereço ${data?.endereco + '-' + data?.numero} deletado!`
                  : `Erro ao deletar ${data?.endereco + '-' + data?.numero} (há dependencias), tente desativar o cadastro!`, error: false
              });
              if (data2.status) {
                this.getPageEndereco(1, this.pageSizeEndereco, this.cadastro.id);
              }
            })
        }
      })
  }

  popUpEndereco(data: any = {}, isNew?) {
    const title = isNew ? 'Novo Endereço' : 'Alterar Endereço';
    if (isNew) {
      data.cadastroId = this.cadastro.id;
    }
    this.dialogRefEndereco = this.dialog.open(EnderecoPopupComponent, {
      width: '98%',
      disableClose: true,
      data: { title: title, payload: data }
    })
    
    this.dialogRefEndereco.afterClosed().subscribe(res => this.reloadPageEndereco());

    // this.dialogRef.afterClosed()
    //   .subscribe(res => {

    //     console.log(`FECHANDO >>> ${JSON.stringify(res)}`);
        
    //     if (!res) {
    //       return;
    //     }
    //     if (this.instanceOfA(res)) {
    //       this.loader.open();
    //       this.cadastroService.saveOrUpdateEndereco(res)
    //         .subscribe(data2 => {
    //           this.loader.close();
    //           this.snack.open('Endereço Salvo com sucesso!', 'OK', { duration: 5500 });
    //           this.reloadPageEndereco();
    //         }, (err: HttpErrorResponse) => {
    //           this.loader.close(); 
    //           this.snack.open('Erro ao savar o endereço!', 'ERRO', { duration: 5500 });
    //         })
    //     } else {
    //       this.confirmService.confirm({
    //         title: 'Município informado incorretamente, verifique!', error: true
    //       });
    //     }
    //   })
  }

  

  setPageSizeOptionsEndereco(event: PageEvent) {
    this.pageSizeEndereco = event.pageSize;
    this.getPageEndereco(event.pageIndex + 1, event.pageSize, this.cadastro.id);
  }

  instanceOfACidade = (p: any): p is Cidade => p.hasOwnProperty('id');


  instanceOfA(object: any): object is Endereco {

    return 'cadMun' in object && this.instanceOfACidade(object.cadMun);
  }


  close() {
    this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
      .subscribe(res => {
        if (res) {
            this.dialogRef.close();
        }
      });
  }


}
